
<script lang="ts">
import { createEventDispatcher } from "svelte";
import { Input, Label } from "sveltestrap";
import { error, success } from "../../public/my-theme";
import { SERVICE_URL } from "../evironment";
import type { AppFileDto } from "../global";
import { getAccessToken } from "../services/session";

const dispatch = createEventDispatcher();

export let file: AppFileDto;

async function saveName(){
    try {
        let url = new URL('/api/files/' + file.id, SERVICE_URL);

        if (SERVICE_URL.includes('localhost') ) {
            url = new URL('/files/' + file.id, SERVICE_URL);
        }
        
        const response = await fetch(url, {
            method: 'PATCH',
            body: JSON.stringify({
                name: file.name,
            }),
            headers: {
                'X-Access-Token': getAccessToken(),
                'content-type' : 'application/json'
            }
        })

        if (!response.ok) {
            error('Error al actualizar el archivo')
            throw new Error('Error al actualizar el fichero');
        }

        success('Archivo actualizado correctamente')

    } catch (error) {
        console.log(error);
    }
}

async function removeFile(){
    if (!confirm('¿Esta seguro de querer eliminar el archivo?')) {
        return
    }

    try {
        let url = new URL('/api/files/' + file.id, SERVICE_URL);

        if (SERVICE_URL.includes('localhost') ) {
            url = new URL('/files/' + file.id, SERVICE_URL);
        }

        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'X-Access-Token': getAccessToken()
            }
        })

        if (!response.ok) {
            error('Error al actualizar el archivo')
            throw new Error('Error al eliminar el fichero');
        }

        dispatch('removeFile', file.id);
        success('Archivo eliminado correctamente')

    } catch (error) {
        console.log(error);
    }
}

async function downloadFile(){
    if (!confirm('¿Esta seguro de querer descargar el archivo?')) {
        return
    }

    try {

        let urlTodown = new URL(`/api/download/${file.id}` , SERVICE_URL);

        if (SERVICE_URL.includes('localhost') ) {
            urlTodown = new URL(`/download/${file.id}` , SERVICE_URL);
        }

        urlTodown.searchParams.set('access_token', getAccessToken());
        const urlDown = urlTodown.toString();

        const link = document.createElement('a');
        link.href = urlDown;
        link.download = 'documento.doc';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(urlDown);

    } catch (error) {
        console.log(error);
    }
}

</script>

<div class="mb-2">
    <Label for="file">Descripción</Label>
    <Input
    type="textarea"
    id="lawyerPart"
    rows={3}
    bind:value={file.name}/>           
</div>
<div class="text-end">
    <button class="btn btn-success" type="button" on:click={saveName}> Guardar </button>
    <button class="btn btn-danger" type="button" on:click={removeFile}> Eliminar </button>
    <button class="btn btn-primary" type="button" on:click={downloadFile}> Descargar </button>
</div>

